import axios from 'axios';

import config from '../config';

const serverUri = config.getServerUri();

export default (routeString, queryString, dataObj) => new Promise((resolve, reject) => {
  const { token } = localStorage;
  axios.put(`${serverUri}${routeString}?${queryString}`, dataObj, {
    headers: {
      authorization: token,
    },
  }).then((res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
